module.exports = __webpack_public_path__ + "static/media/coffee.dd021b94.jpg";